import { DEFAULT_LOCALE, DEFAULT_TIMEZONE } from "./constants";

/** ₹1,49,900 style formatting (Indian digit grouping). Amounts are in paise. */
export function formatINR(paise: number, opts: { decimals?: boolean } = {}): string {
  return new Intl.NumberFormat(DEFAULT_LOCALE, {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: opts.decimals ? 2 : 0,
    minimumFractionDigits: opts.decimals ? 2 : 0,
  }).format(paise / 100);
}

/** "3 Oct 2026" */
export function formatDate(iso: string | Date | null | undefined, timeZone = DEFAULT_TIMEZONE): string {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso.length === 10 ? `${iso}T00:00:00+05:30` : iso) : iso;
  return new Intl.DateTimeFormat(DEFAULT_LOCALE, { day: "numeric", month: "short", year: "numeric", timeZone }).format(d);
}

/** "3 Oct 2026, 4:05 pm" */
export function formatDateTime(iso: string | Date | null | undefined, timeZone = DEFAULT_TIMEZONE): string {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  return new Intl.DateTimeFormat(DEFAULT_LOCALE, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone,
  }).format(d);
}

export function timeAgo(iso: string | Date, now: Date = new Date()): string {
  const d = typeof iso === "string" ? new Date(iso) : iso;
  const s = Math.round((now.getTime() - d.getTime()) / 1000);
  if (s < 45) return "just now";
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  const days = Math.round(h / 24);
  if (days < 7) return `${days}d ago`;
  return formatDate(d);
}

/** "+91 98765 43210" */
export function formatIndianPhone(e164: string | null | undefined): string {
  if (!e164) return "";
  const m = /^\+91(\d{5})(\d{5})$/.exec(e164);
  return m ? `+91 ${m[1]} ${m[2]}` : e164;
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join("");
}

/** Very small template renderer for {{variable}} placeholders. Unknown vars render empty. */
export function renderTemplate(tpl: string, vars: Record<string, string | number | null | undefined>): string {
  return tpl.replace(/\{\{\s*([a-z0-9_]+)\s*\}\}/gi, (_, key: string) => {
    const v = vars[key];
    return v === null || v === undefined ? "" : String(v);
  });
}
